module.exports = __webpack_public_path__ + "img/figures-2.b1268707.png";